import React from 'react';
import moment from 'moment';

import {
    Table,
    Card,
    Popover,
    Button,
    Modal,
    Input,
} from 'antd'

import {
    _getBugLogs,
} from '../../services'

class Logs extends React.Component {

    constructor(props){
        super(props)

        this.state={
            page: 1,
            limit: 10,
            total: false,
            logs: this.props.logs,
            modalVisible: false,
            messageFromUser: '',
        }
    }

    render() {

        const timestamp = 'MMMM DD, YYYY h:mm A'

        const columns = [{
            title: 'Timestamp',
            dataIndex: 'dateCreated',
            render:(dateCreated) => moment(dateCreated).format(timestamp),
            width: 220,
        }, {
            title: 'Description',
            dataIndex: 'description',
            render: (description, record) => this.renderDescription(description, record)
        }]

        const {limit, page, total} = this.state;

        return(
            <div>
                <div className="logs-title-container"> 
                    <p>Logs</p>
                    <Button
                        onClick={() => this.setState({modalVisible: true})}
                        size="small"
                        style={{ marginLeft: 16 }}
                        type="primary"
                    >Log Email from User</Button>

                    {this.renderLogMessageModal()}

                </div>
                <Card
                style={{ minHeight: 500}}
                bordered={false}
                >
                    <Table
                        size="small"
                        columns={columns}
                        dataSource={this.props.logs}
                        rowKey={'_id'}
                        pagination={{
                            pageSize: limit,
                            current: page,
                            total,
                            onChange: (nextPage)=>this.setState({ page: nextPage }, this.getLogs)
                        }}
                    />
                </Card>
            </div>
        )
    }

    renderDescription = (description, record) => {
        if (description=='Email sent to User') {
            return (
                <span>
                <Popover content={record.message}><a>Email </a></Popover>
                sent to User
                </span>
            )
        } 

        if (description=='Email from User') {
            return (
                <span>
                <Popover content={record.message}><a>Email </a></Popover>
                from User
                </span>
            )
        } 
        
        return description
        
    }

    renderLogMessageModal = () => {

        return(
            <Modal 
                onOk={this.handleOkPress}
                afterClose={()=>this.setState({modalVisible: false})}
                onCancel={()=>this.setState({modalVisible: false})}
                title="Message from User"
                closable={false}
                centered
                visible={this.state.modalVisible}
                width={'70%'}
                >
                <Input.TextArea
                    rows={4}
                    placeholder="Message"
                    onChange={(e)=>this.setState({messageFromUser: e.target.value})}
                    style={{width: '100%'}}
                />
            </Modal>
        )
    }

    handleOkPress = () => {
        this.props.logUserEmail(this.state.messageFromUser)
        this.setState({modalVisible: false})
    }

}

export default Logs;


// WEBPACK FOOTER //
// ./src/components/bug-report/logs.js